var _path;
import * as React from "react";
var SvgLogout = function SvgLogout(props) {
  return /*#__PURE__*/React.createElement("svg", props, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.333 7.556 15.08 8.809l2.293 2.302h-9.04v1.778h9.04l-2.293 2.293 1.253 1.262L20.778 12l-4.445-4.444ZM4.778 5.778h7.11V4h-7.11C3.8 4 3 4.8 3 5.778v12.444C3 19.2 3.8 20 4.778 20h7.11v-1.778h-7.11V5.778Z"
  })));
};
export default SvgLogout;